import { Action, Selector, State, StateContext, Store } from '@ngxs/store';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { NotificationService } from '../../../../../../common/services';
import { AllocationViewArrivalDockModel } from '../../models';
import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import {
  AllocationViewArriveAtDockConfirmationAction,
  AllocationViewArriveAtDockConfirmationActionPrepare,
  AllocationViewArriveAtDockConfirmationActionSetInitialState,
} from './allocation-view-arrive-at-dock-confirmation-action.actions';
import { AllocationViewArriveAtDockConfirmationActionService } from './allocation-view-arrive-at-dock-confirmation-action.service';
import { AllocationViewActionBaseState } from '../base';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export interface AllocationViewArriveAtDockConfirmationActionStateModel {
  loaded: boolean;
  arriveAtDockConfirmationPrepareData: AllocationViewArrivalDockModel;
}

const initialState: AllocationViewArriveAtDockConfirmationActionStateModel = {
  loaded: false,
  arriveAtDockConfirmationPrepareData: null,
};

@State({
  name: 'allocationViewActionsArriveAtDockConfirmation',
  defaults: initialState,
})
@Injectable()
export class AllocationViewArriveAtDockConfirmationActionState extends AllocationViewActionBaseState {
  @Selector()
  static getLoaded(state: AllocationViewArriveAtDockConfirmationActionStateModel): boolean {
    return state.loaded;
  }

  @Selector()
  static getArriveAtDockConfirmationPrepareData(
    state: AllocationViewArriveAtDockConfirmationActionStateModel,
  ): AllocationViewArrivalDockModel {
    return state.arriveAtDockConfirmationPrepareData;
  }

  constructor(
    private allocationViewArriveAtDockConfirmationActionService: AllocationViewArriveAtDockConfirmationActionService,
    notificationService: NotificationService,
    store: Store,
  ) {
    super(notificationService, store);
  }

  @Action(AllocationViewArriveAtDockConfirmationAction)
  dockArrivalConfirmation(
    ctx: StateContext<AllocationViewArriveAtDockConfirmationActionStateModel>,
    { data }: AllocationViewArriveAtDockConfirmationAction,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.allocationViewArriveAtDockConfirmationActionService.arriveAtDockConfirmation(data).pipe(
      tap(() => {
        this.finishAction('api.uli.success.dockArrivalConfirmation');
      }),
      catchError(({ error }: HttpErrorResponse) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(AllocationViewArriveAtDockConfirmationActionPrepare)
  dockArrivalConfirmationPrepare(
    ctx: StateContext<AllocationViewArriveAtDockConfirmationActionStateModel>,
    { identifier, language }: AllocationViewArriveAtDockConfirmationActionPrepare,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | AllocationViewArrivalDockModel> {
    return this.allocationViewArriveAtDockConfirmationActionService
      .arriveAtDockConfirmationPrepare(identifier, language)
      .pipe(
        tap((response: AllocationViewArrivalDockModel) => {
          ctx.patchState({
            arriveAtDockConfirmationPrepareData: response,
            loaded: true,
          });
        }),
        catchError(({ error }: HttpErrorResponse) => of(this.notificationService.error(error.message))),
      );
  }

  @Action(AllocationViewArriveAtDockConfirmationActionSetInitialState)
  setInitialState(ctx: StateContext<AllocationViewArriveAtDockConfirmationActionStateModel>): void {
    ctx.setState(initialState);
    this.setContainerAfterActionEffectsInitialState();
  }
}
